import { SupportModal, SpinnerSmall } from 'app/components';
import { i18n } from 'app/utils/i18n';

export const TemplateSidebar = (props) => {
  const { style, onStyleChange, errorMessage, isSaving } = props;

  return (
    <div className="template-toolbar flex-1 ms-4 mt-5">
      {errorMessage && (
        <div className="alert alert-danger" role="alert">
          <p>Något är fel med stylingen, korrigera koden för att spara på nytt.</p>
          {<code style={{ whiteSpace: 'pre-wrap' }}>{errorMessage}</code>}
        </div>
      )}
      <div className="nav nav-tabs">
        <span className="nav-link active flex-grow-1 d-flex align-items-center">
          <span className="flex-grow-1 text-center">{i18n('template-editor.page-structure')}</span>
          {isSaving && <SpinnerSmall />}
        </span>
      </div>
      <div className="bg-light p-3 border-gray-300 border-bottom border-start border-end">
        <small className="text-muted d-block mb-2">{i18n('template-editor.custom-style-hint')}</small>
        <textarea
          className="w-100 resize-none border border-gray-300 rounded p-2"
          rows={30}
          value={style}
          onChange={(e) => onStyleChange(e.target.value)}
          style={{ fontFamily: 'monospace', fontSize: '0.8125rem' }}
        ></textarea>
      </div>
      {props.children}
      <SupportModal />
    </div>
  );
};
